<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="NewReturnsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <vue-element-loading :active="isLoading" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('common.addition') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-scroll-x" ref="xscroll">
            <table class="table table-striped table-align-top table-1200 no-margin-bottom font-size-smaller">
              <thead>
                <tr>
                  <th class="unlimited_no_th">No.</th>
                  <th>{{ translations('return.reason_return') }}</th>
                  <th></th>
                  <th>{{ translations('return.operation_confirmation') }}</th>
                  <th>{{ translations('return.verification_results') }}</th>
                  <th>JAN / ITEM# / {{ translations('return.model_number') }}</th>
                  <th>{{ translations('return.number_item') }}</th>
                  <th>{{ translations('return.unit_price') }}</th>
                  <th>{{ translations('return.summary') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
              <template v-for="(tempDetail, i) in tempDetails">
                <tr :key="i">
                  <td class="unlimited_no_td">
                    {{i+1}}
                  </td>
                  <td>
                    <v-select ref="reasonSelect" v-model="selectedReason[i]" :options="reasons" @input="clicked('selectedReason', i)"></v-select>
                  </td>
                  <td>
                    <button type="button" class="btn btn-secondary" @click="addReasonForReturn(true, i)">{{ translations('common.addition') }}</button>
                    <input v-if="isPressedButton[i]" v-model="reason_for_return[i].temp_jp" class="form-control form-control-sm min-width-120 min-height-35 margin-top-5" type="text" :placeholder="reason_for_return[i].jp" @click="clicked('temp_jp', i)">
                    <input v-if="isPressedButton[i]" v-model="reason_for_return[i].temp_us" class="form-control form-control-sm min-width-120 min-height-35 margin-top-2" type="text" :placeholder="reason_for_return[i].us" @click="clicked('temp_us', i)">
                  </td>
                  <td>
                    <select v-model="tempDetail.return_state_id" class="custom-select keep-select">
                      <template  v-for="(state, i) in return_states">
                        <option :key="i" :value="state.id">{{ state.name }}</option>
                      </template>
                    </select>
                  </td>
                  <td>
                    <input v-model="tempDetail.test_result" class="form-control form-control-sm min-width-80 min-height-35" type="text">
                  </td>
                  <td>
                    <v-select :filter="searchProduct" @input="selectProduct(i)" v-model="selectedProduct[i]" :options="productList" label="label" value="id"></v-select>
                  </td>
                  <td>
                    <input v-on:keyup="quantityKeyUp($event,tempDetail)" v-model="tempDetail.quantity" class="form-control form-control-sm min-width-60 min-height-35 input-right" type="text">
                  </td>
                  <td>
                    <input v-model="tempDetail.unit_price" class="form-control form-control-sm min-width-80 min-height-35 input-right" type="text">
                  </td>
                  <td>
                    <input v-model="tempDetail.remarks" class="form-control form-control-sm min-width-60 min-height-35" type="text">
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <div>
            <button type="button" class="btn btn-info" @click="addRows(10)">{{ translations('return.add_row') }}</button>
          </div>
          <div>
            <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal" @click="addReasonForReturn()">{{ translations('common.close') }}</button>
            <button type="button" class="btn btn-primary margin-left-10" @click="updateDetails()">{{ translations('common.update') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'NewReturnsModal',
  components: {
    VueElementLoading
  },
  props: {
    vat: {}, // VAT
    returnDetails: {},
    returnStatuses: {},
    returnReasons: {},
    returnStates: {},
    products: {}
  },
  data () {
    return {
      rows: 10,
      return_products: [],
      tempDetails: [],
      reason_for_return: [],
      testData: [],
      isLoading: false,
      isPressedButton: [],
      reasons: [],
      productList: [],
      searchReasons: {},
      searchProducts: {},
      selectedReason: [],
      selectedProduct: []
    }
  },
  created () {
    this.emptyDetail()
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.changeLoadingStatus)
  },
  computed: {
    ...mapState(['currentLanguage']),
    return_states () {
      const states = this.$props.returnStates
      return this.translateStates(states)
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(state.name)
      }))
    },
    quantityKeyUp (event, tempDetail) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      tempDetail.quantity = value
    },
    emptyDetail () {
      this.rows = 10
      this.tempDetails = []
      this.reason_for_return = []
      this.isPressedButton = []
      this.selectedReason = []
      this.selectedProduct = []
      for (let i = 0; i < this.rows; i++) {
        this.tempDetails.push({
          taxclass_id: '1', // TAXSTATUS
          unit_price: '',
          quantity: '',
          remarks: '',
          return_reason_id: '',
          return_reason_name: '',
          return_state_id: 5,
          return_status_id: 1,
          test_result: '',
          product_id: '',
          from_warehouse: {
            id: 0,
            name: ''
          }
        })
        this.reason_for_return.push({
          jp: '返品理由',
          us: 'Reason for return',
          temp_jp: '',
          temp_us: ''
        })
        this.isPressedButton.push(false)
        this.selectedReason.push('')
        this.selectedProduct.push('')
      }
    },
    clicked (button, i) {
      if (button === 'temp_jp' || button === 'temp_us') {
        this.selectedReason[i] = ''
      } else if (button === 'selectedReason' && this.selectedReason[i] !== null) {
        // console.log('### selectedReason:' + this.selectedReason) // DEBUG
        this.reason_for_return[i].temp_jp = ''
        this.reason_for_return[i].temp_us = ''
        this.isPressedButton[i] = false
      } else {
        // DO NOTHING
      }
    },
    addRows (rows) {
      if (!rows) return
      for (let i = 0; i < rows; i++) {
        this.tempDetails.push({
          taxclass_id: '1', // TAXSTATUS
          unit_price: '',
          quantity: '',
          remarks: '',
          return_reason_id: '',
          return_reason_name: '',
          return_state_id: 5,
          return_status_id: 1,
          test_result: '',
          product_id: ''
        })
        this.reason_for_return.push({
          jp: '返品理由',
          us: 'Reason for return',
          temp_jp: '',
          temp_us: ''
        })
        this.isPressedButton.push(false)
        this.selectedReason.push('')
        this.selectedProduct.push('')
        this.rows++ // ADD
      }
    },
    addReasonForReturn (button, i) {
      this.$refs['xscroll'].scrollTo(0, 0) // INIT
      if (i === undefined || i === null) {
        this.emptyDetail() // CLEAR ALL !!
        return // BREAK
      }
      if (button) {
        this.isPressedButton[i] = !(this.isPressedButton[i])
      } else {
        this.isPressedButton[i] = false
      }
      if (this.isPressedButton[i]) {
        this.selectedReason[i] = ''
      } else {
        this.reason_for_return[i].temp_jp = ''
        this.reason_for_return[i].temp_us = ''
      }
      this.$forceUpdate() // FORCE UPDATE // REFRESH
    },
    changeLoadingStatus () {
      this.isLoading = false
      let $this = this
      this.reasons = []
      this.productList = []
      this.searchProducts = {}
      this.searchReasons = {}
      this.$props.returnReasons.forEach(function (reason) {
        if (reason.is_temporary !== '1') {
          $this.reasons.push(reason.name)
          $this.searchReasons[reason.name] = { id: reason.id }
        }
      })
      this.$props.products.forEach(function (product) {
        product.label = product.jan_code + ' / ' + product.item_no + ' / ' + product.model
        product.search = product.jan_code + ' / ' + product.item_no + ' / ' + product.model + ' / ' + product.description + ' / ' + product.legacy_code
        $this.productList.push(product)
        $this.searchProducts[product.id] = product
      })
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
    async getNewReturnReasonId (i) { // REASON FOR RETURN
      try {
        let result = await this.$http.post(this.$api_url.return_add_reason, { name: this.reason_for_return[i].temp_jp, name_eng: this.reason_for_return[i].temp_us })
        if (result.data.status === true) {
          // console.log('### result.data:' + JSON.stringify(result.data))
          // console.log('### result.data.id:' + JSON.stringify(result.data.id))
          this.tempDetails[i].return_reason_id = result.data.id
        } else {
          this.$toastr.error(result.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('NewReturnsModal:getNewReturnReasonId:catch(error): ', this.translations('common.error'))
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }
    },
    async updateDetails () {
      console.log(JSON.stringify(this.tempDetails)) // DEBUG

      let newReturnDetail = []
      const _async = async () => {
        let isError = false
        for (let i = 0; i < this.rows; i++) {
          if (this.tempDetails[i] && this.tempDetails[i].product_id) {
            const product = this.tempDetails[i]
            let unitPrice = product.unit_price
            let unitPriceIncTax = unitPrice

            console.log(product)

            if (product.unit_price === '' || !product.quantity || !product.return_state_id || !product.return_status_id) {
              this.$toastr.warning(1 + i + this.translations('return.notice_enter_required_data_line'), this.translations('common.warning'))
              isError = true
              return // BREAK
            } else if (isNaN(this.tempDetails[i].unit_price) || isNaN(this.tempDetails[i].quantity)) {
              this.$toastr.warning(1 + i + this.translations('return.notice_enter_valid_number_line'), this.translations('common.warning'))
              isError = true
              return // BREAK
            }

            if (this.selectedReason[i]) {
              product.return_reason_id = this.searchReasons[this.selectedReason[i]].id
              product.return_reason_name = this.selectedReason[i] // SAVE NEW REASON
            } else if (this.reason_for_return[i].temp_jp) { // JP ONLY
              product.return_reason_name = this.reason_for_return[i].temp_jp // SAVE NEW REASON
              await this.getNewReturnReasonId(i)
            } else {
              this.$toastr.warning(1 + i + this.translations('return.notice_enter_reason_line'), this.translations('common.warning'))
              isError = true
              return // BREAK
            }

            if (this.vat.taxIncluded) {
              unitPriceIncTax = unitPrice
              unitPrice = this.$util.getExcludeTax(unitPriceIncTax, this.vat.vatRate)
            } else {
              unitPriceIncTax = this.$util.getIncludeTax(unitPrice, this.vat.vatRate)
            }

            for (let i = 0; i < product.quantity; i++) {
              const data = JSON.parse(JSON.stringify(product))
              data.quantity = 1
              data.unit_price = unitPrice
              data.unit_price_inctax = unitPriceIncTax
              newReturnDetail.push(data)
            }
          }
        }
        this.$props.returnDetails.push(...newReturnDetail)
        if (!isError) {
          this.emptyDetail()
          this.$refs.closeModal.click()
        }
      }
      _async() // ASYNC await INSIDE
    },
    searchProduct (options, search) {
      return options.filter(option => {
        return option.search.indexOf(search) >= 0
      })
    },
    selectProduct (i) {
      const v = this.selectedProduct
      if (this.searchProducts[v[i].id]) {
        const product = this.searchProducts[v[i].id]
        this.tempDetails[i].product_id = product.id
        this.tempDetails[i].item_no = product.item_no
        this.tempDetails[i].jan_code = product.jan_code
        this.tempDetails[i].model = product.model
        this.tempDetails[i].unit_price = product.unit_price
        this.tempDetails[i].row_price = product.row_price
        this.tempDetails[i].unit_price_inctax = product.unit_price_inctax
        this.tempDetails[i].taxclass_id = product.taxclass_id
        this.tempDetails[i].tax_status = product.tax_status
        this.tempDetails[i].tax_included = product.tax_included
        this.tempDetails[i].tax_rate = product.tax_rate
      }
    }
  }
}
</script>
